import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IMPORTS } from './_imports';

@Component({
    selector: 'pdf-preview-dialog',
    templateUrl: './pdf-preview-dialog.component.html',
    styleUrl: './pdf-preview-dialog.component.scss',
    standalone: true,
    imports: IMPORTS
})
export class PdfPreviewDialogComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: string,
        private dialogRef: MatDialogRef<PdfPreviewDialogComponent>
    ) { }

    close() {
        this.dialogRef.close();
    }

    // #region [===== private methods =====]
    // #endregion
}
